/**
 * Client-portal table view of accounts. Thin wrapper around the shared
 * common-web `AccountsListTable` that passes `detailRoutePrefix` from the
 * caller. Kept as a per-portal component so future client-specific row
 * actions can land here without disturbing the shared table.
 */

import React from 'react';
import {
  AccountsListTable,
  type AccountsListTableRow,
} from '@common-web/components/account/AccountsListTable';
import type {AccountCardData} from './AccountCard';

interface AccountTableProps {
  accounts: AccountCardData[];
  routePrefix: string;
}

// `AccountCardData` includes a few card-only fields (_canTransition); strip
// those before handing rows to the shared table.
function toTableRow(account: AccountCardData): AccountsListTableRow {
  const {_canTransition: _drop, ...rest} = account;
  return rest;
}

export function AccountTable({accounts, routePrefix}: AccountTableProps): React.ReactElement {
  const rows = accounts.map(toTableRow);
  return <AccountsListTable accounts={rows} detailRoutePrefix={routePrefix} />;
}
